export default __webpack_public_path__ + "static/media/notification_white.d78cb85e.svg";